import { replaceAllSpacesWithDashes } from '../replaceAllSpaces'
import listItem from './listItem'
import { BreadcrumbList, WithContext } from 'schema-dts'
import { PageType } from '@/types/models/PageType.model'

export const breadcrumbTaxonomyMappings = {
  'Location+who_we_treat': 'clientele',
  'Location+price': 'price',
  'Location+what_we_treat': 'condition',
  'Location+activity': 'activities',
  'Location+activities': 'activities',
  'Location+treatment_therapies': 'therapies',
  'Location+amenity': 'amenities',
  'Location+amenities': 'amenities',
  'Location+setting': 'setting',
  'Location+treatment_services': 'care',
  'Location+accepted_insurance': 'insurance',
  'Location+treatment_method': 'approach',
  'Location+treatment_methods': 'approach'
}

const breadcrumbSchema = ({
  breadcrumbs = [],
  pageType,
  termTitle,
  termSlug
}: {
  breadcrumbs: string[]
  pageType: PageType
  termTitle?: string
  termSlug?: string
}): WithContext<BreadcrumbList> => {
  const breadcrumbSchema: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList'
  }

  const filteredBreadcrumbs =
    breadcrumbs.filter((breadcrumb) => breadcrumb !== 'North America') || []

  if (filteredBreadcrumbs.length === 0) {
    return {
      ...breadcrumbSchema,
      itemListElement: [listItem(1, 'https://recovery.com', 'Home')]
    }
  }

  const itemListElement = breadcrumbs.map((breadcrumb, index) => {
    const normalizedBreadCrumb = replaceAllSpacesWithDashes(
      breadcrumb.toLowerCase()
    )

    const slug =
      breadcrumb === termTitle
        ? `${breadcrumbTaxonomyMappings[pageType]}/${
            termSlug || normalizedBreadCrumb
          }`
        : normalizedBreadCrumb

    const url = slug ? `https://recovery.com/${slug}/` : 'https://recovery.com'
    const name = breadcrumb || 'Home'
    const itemListPosition = index + 1

    return listItem(itemListPosition, url, name)
  })

  return {
    ...breadcrumbSchema,
    itemListElement
  }
}

export default breadcrumbSchema
